module.exports = __webpack_public_path__ + "static/img/channel-2-7.f5176462.png";